var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      staticClass: "immediate-dialog",
      attrs: {
        title: _vm.dialogTitle,
        visible: _vm.dialogVisible,
        width: "800px",
        "close-on-click-modal": false,
        "close-on-press-escape": false,
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
        close: _vm.handleClose,
      },
    },
    [
      _c(
        "el-form",
        {
          ref: "form",
          staticClass: "immediate-form",
          attrs: {
            model: _vm.form,
            rules: _vm.rules,
            "label-width": "120px",
            size: "small",
          },
        },
        [
          _c(
            "el-row",
            { attrs: { gutter: 20 } },
            [
              _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "排序", prop: "sort" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请输入排序", clearable: "" },
                        model: {
                          value: _vm.form.sort,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "sort", $$v)
                          },
                          expression: "form.sort",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-row",
            { attrs: { gutter: 20 } },
            [
              _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "活动名称", prop: "name" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请输入活动名称", clearable: "" },
                        model: {
                          value: _vm.form.name,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "name", $$v)
                          },
                          expression: "form.name",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-row",
            { attrs: { gutter: 20 } },
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "开始时间", prop: "startTime" } },
                    [
                      _c("el-date-picker", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          type: "datetime",
                          placeholder: "选择开始时间",
                          "value-format": "yyyy-MM-dd HH:mm:ss",
                        },
                        model: {
                          value: _vm.form.startTime,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "startTime", $$v)
                          },
                          expression: "form.startTime",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "结束时间", prop: "endTime" } },
                    [
                      _c("el-date-picker", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          type: "datetime",
                          placeholder: "选择结束时间",
                          "value-format": "yyyy-MM-dd HH:mm:ss",
                        },
                        model: {
                          value: _vm.form.endTime,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "endTime", $$v)
                          },
                          expression: "form.endTime",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-row",
            { attrs: { gutter: 20 } },
            [
              _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "油品类型", prop: "productCodes" } },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "100%" },
                          attrs: {
                            placeholder: "请选择油品类型",
                            multiple: "",
                            filterable: "",
                            remote: "",
                            "reserve-keyword": "",
                            "remote-method": _vm.searchOilTypes,
                            loading: _vm.gunLoading,
                          },
                          model: {
                            value: _vm.form.productCodes,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "productCodes", $$v)
                            },
                            expression: "form.productCodes",
                          },
                        },
                        _vm._l(_vm.oilTypeOptions, function (item) {
                          return _c("el-option", {
                            key: item.id,
                            attrs: { label: item.name, value: item.id },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-row",
            { attrs: { gutter: 20 } },
            [
              _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "活动类型", prop: "type" } },
                    [
                      _c(
                        "el-radio-group",
                        {
                          model: {
                            value: _vm.form.type,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "type", $$v)
                            },
                            expression: "form.type",
                          },
                        },
                        [
                          _c("el-radio", { attrs: { label: 1 } }, [
                            _vm._v("每升优惠"),
                          ]),
                          _vm._v(" "),
                          _c("el-radio", { attrs: { label: 2 } }, [
                            _vm._v("总金额优惠"),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-row",
            { attrs: { gutter: 20 } },
            [
              _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "绑定加油站", prop: "stationCodes" } },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "100%" },
                          attrs: {
                            placeholder: "请选择加油站",
                            multiple: "",
                            filterable: "",
                            remote: "",
                            "reserve-keyword": "",
                            "remote-method": _vm.searchMerchants,
                            loading: _vm.merchantLoading,
                          },
                          on: { change: _vm.handleStationChange },
                          model: {
                            value: _vm.form.stationCodes,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "stationCodes", $$v)
                            },
                            expression: "form.stationCodes",
                          },
                        },
                        _vm._l(_vm.merchantOptions, function (item) {
                          return _c("el-option", {
                            key: item.id,
                            attrs: { label: item.name, value: item.id },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-row",
            { attrs: { gutter: 20 } },
            [
              _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "备注", prop: "remark" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请输入备注", clearable: "" },
                        model: {
                          value: _vm.form.remark,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "remark", $$v)
                          },
                          expression: "form.remark",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "discount-section" }, [
            _c("div", { staticClass: "section-title" }, [
              _c("span", [_vm._v("优惠设置")]),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "rule-item" },
              [
                _c(
                  "el-row",
                  { attrs: { gutter: 20 } },
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 24 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: "规则名称:",
                              prop: "rules.0.ruleName",
                            },
                          },
                          [
                            _c("el-input", {
                              attrs: {
                                placeholder: "请输入规则名称",
                                clearable: "",
                              },
                              model: {
                                value: _vm.form.rules[0].ruleName,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form.rules[0], "ruleName", $$v)
                                },
                                expression: "form.rules[0].ruleName",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-row",
                  { attrs: { gutter: 20 } },
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 24 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "时间类型:" } },
                          [
                            _c(
                              "el-radio-group",
                              {
                                model: {
                                  value: _vm.form.rules[0].ruleType,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form.rules[0], "ruleType", $$v)
                                  },
                                  expression: "form.rules[0].ruleType",
                                },
                              },
                              [
                                _c("el-radio", { attrs: { label: 1 } }, [
                                  _vm._v("自然日"),
                                ]),
                                _vm._v(" "),
                                _c("el-radio", { attrs: { label: 2 } }, [
                                  _vm._v("自然周"),
                                ]),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.form.rules[0].ruleType === 2
                  ? _c(
                      "el-row",
                      { attrs: { gutter: 20 } },
                      [
                        _c(
                          "el-col",
                          { attrs: { span: 24 } },
                          [
                            _c(
                              "el-form-item",
                              { attrs: { label: "规则设置:" } },
                              [
                                _c(
                                  "div",
                                  { staticClass: "rule-time-selector" },
                                  [
                                    _c(
                                      "el-select",
                                      {
                                        staticStyle: { width: "100px" },
                                        attrs: { placeholder: "周..." },
                                        model: {
                                          value: _vm.form.rules[0].weekStart,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.form.rules[0],
                                              "weekStart",
                                              $$v
                                            )
                                          },
                                          expression: "form.rules[0].weekStart",
                                        },
                                      },
                                      [
                                        _c("el-option", {
                                          attrs: { label: "周一", value: 1 },
                                        }),
                                        _vm._v(" "),
                                        _c("el-option", {
                                          attrs: { label: "周二", value: 2 },
                                        }),
                                        _vm._v(" "),
                                        _c("el-option", {
                                          attrs: { label: "周三", value: 3 },
                                        }),
                                        _vm._v(" "),
                                        _c("el-option", {
                                          attrs: { label: "周四", value: 4 },
                                        }),
                                        _vm._v(" "),
                                        _c("el-option", {
                                          attrs: { label: "周五", value: 5 },
                                        }),
                                        _vm._v(" "),
                                        _c("el-option", {
                                          attrs: { label: "周六", value: 6 },
                                        }),
                                        _vm._v(" "),
                                        _c("el-option", {
                                          attrs: { label: "周日", value: 7 },
                                        }),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c("el-time-picker", {
                                      staticStyle: { width: "120px" },
                                      attrs: {
                                        placeholder: "选择时间",
                                        format: "HH:mm",
                                        "value-format": "HH:mm",
                                      },
                                      model: {
                                        value: _vm.form.rules[0].startTime,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.form.rules[0],
                                            "startTime",
                                            $$v
                                          )
                                        },
                                        expression: "form.rules[0].startTime",
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c("span", { staticClass: "separator" }, [
                                      _vm._v("至"),
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "el-select",
                                      {
                                        staticStyle: { width: "100px" },
                                        attrs: { placeholder: "周..." },
                                        model: {
                                          value: _vm.form.rules[0].weekEnd,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.form.rules[0],
                                              "weekEnd",
                                              $$v
                                            )
                                          },
                                          expression: "form.rules[0].weekEnd",
                                        },
                                      },
                                      [
                                        _c("el-option", {
                                          attrs: { label: "周一", value: 1 },
                                        }),
                                        _vm._v(" "),
                                        _c("el-option", {
                                          attrs: { label: "周二", value: 2 },
                                        }),
                                        _vm._v(" "),
                                        _c("el-option", {
                                          attrs: { label: "周三", value: 3 },
                                        }),
                                        _vm._v(" "),
                                        _c("el-option", {
                                          attrs: { label: "周四", value: 4 },
                                        }),
                                        _vm._v(" "),
                                        _c("el-option", {
                                          attrs: { label: "周五", value: 5 },
                                        }),
                                        _vm._v(" "),
                                        _c("el-option", {
                                          attrs: { label: "周六", value: 6 },
                                        }),
                                        _vm._v(" "),
                                        _c("el-option", {
                                          attrs: { label: "周日", value: 7 },
                                        }),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c("el-time-picker", {
                                      staticStyle: { width: "120px" },
                                      attrs: {
                                        placeholder: "选择时间",
                                        format: "HH:mm",
                                        "value-format": "HH:mm",
                                      },
                                      model: {
                                        value: _vm.form.rules[0].endTime,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.form.rules[0],
                                            "endTime",
                                            $$v
                                          )
                                        },
                                        expression: "form.rules[0].endTime",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.form.type === 2
                  ? [
                      _c(
                        "el-row",
                        { attrs: { gutter: 20 } },
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 24 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "优惠门槛:",
                                    prop: "rules.0.condition",
                                  },
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "threshold-content" },
                                    [
                                      _c(
                                        "span",
                                        { staticClass: "threshold-text" },
                                        [_vm._v("满")]
                                      ),
                                      _vm._v(" "),
                                      _c("el-input-number", {
                                        staticStyle: { width: "300px" },
                                        attrs: {
                                          min: 0,
                                          precision: 2,
                                          placeholder: "0.00",
                                        },
                                        model: {
                                          value: _vm.form.rules[0].condition,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.form.rules[0],
                                              "condition",
                                              $$v
                                            )
                                          },
                                          expression: "form.rules[0].condition",
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c("span", { staticClass: "unit" }, [
                                        _vm._v("元"),
                                      ]),
                                    ],
                                    1
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-row",
                        { attrs: { gutter: 20 } },
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 24 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "优惠内容:",
                                    prop: "rules.0.reward",
                                  },
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "discount-content-wrapper" },
                                    [
                                      _c(
                                        "span",
                                        { staticClass: "discount-text" },
                                        [_vm._v("订单金额优惠")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "discount-sub-line" },
                                        [
                                          _c(
                                            "span",
                                            { staticClass: "discount-text" },
                                            [_vm._v("减")]
                                          ),
                                          _vm._v(" "),
                                          _c("el-input-number", {
                                            staticStyle: { width: "300px" },
                                            attrs: {
                                              min: 0,
                                              precision: 2,
                                              placeholder: "0.00",
                                            },
                                            model: {
                                              value: _vm.form.rules[0].reward,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.form.rules[0],
                                                  "reward",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "form.rules[0].reward",
                                            },
                                          }),
                                          _vm._v(" "),
                                          _c("span", { staticClass: "unit" }, [
                                            _vm._v("元"),
                                          ]),
                                        ],
                                        1
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]
                  : _vm._e(),
                _vm._v(" "),
                _vm.form.type === 1
                  ? [
                      _c(
                        "el-row",
                        { attrs: { gutter: 20 } },
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 24 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "优惠金额:",
                                    prop: "rules.0.discount",
                                  },
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "discount-content-wrapper" },
                                    [
                                      _c(
                                        "span",
                                        { staticClass: "discount-text" },
                                        [_vm._v("每升优惠")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "discount-sub-line" },
                                        [
                                          _c(
                                            "span",
                                            { staticClass: "discount-text" },
                                            [_vm._v("减")]
                                          ),
                                          _vm._v(" "),
                                          _c("el-input-number", {
                                            staticStyle: { width: "300px" },
                                            attrs: {
                                              min: 0,
                                              precision: 2,
                                              placeholder: "0.00",
                                            },
                                            model: {
                                              value: _vm.form.rules[0].discount,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.form.rules[0],
                                                  "discount",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "form.rules[0].discount",
                                            },
                                          }),
                                          _vm._v(" "),
                                          _c("span", { staticClass: "unit" }, [
                                            _vm._v("元"),
                                          ]),
                                        ],
                                        1
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]
                  : _vm._e(),
              ],
              2
            ),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c("el-button", { on: { click: _vm.handleClose } }, [_vm._v("取消")]),
          _vm._v(" "),
          _c(
            "el-button",
            {
              attrs: { type: "primary", loading: _vm.submitLoading },
              on: { click: _vm.handleSubmit },
            },
            [_vm._v("\n      确定\n    ")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }